<template>
  <div class="container-fluid">
    <div
      v-for="attribute in errors"
      class="alert alert-danger"
      :key="attribute.field"
    >
      {{ attribute.value }}
    </div>
    <h4 class="m-3">Изменение магазина</h4>
    <el-form
      ref="form"
      :model="form"
      label-width="160px"
      id="uploadForm"
      name="uploadForm"
      enctype="multipart/form-data"
    >
      <el-form-item label="Город">
        <el-input v-model="form.title" disabled></el-input>
      </el-form-item>
      <el-form-item label="Адрес">
        <el-input v-model="form.address" disabled></el-input>
      </el-form-item>
      <el-form-item label="Почта">
        <el-input v-model="form.email" disabled></el-input>
      </el-form-item>
      <el-form-item label="Время работы">
        <el-input v-model="form.workTime" disabled></el-input>
      </el-form-item>
      <el-form-item label="Телефон">
        <el-input v-model="form.phone" disabled></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Широта">
        <el-input v-model="form.coordinates.latitude"></el-input>
      </el-form-item>
      <el-form-item label="Долгота">
        <el-input v-model="form.coordinates.longitude"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-alert type="info" show-icon :closable="false">
        <p>
          Опрежделяет возможность добавить доставку при оформлении заказа в
          текущем магазине
        </p>
      </el-alert>
      <el-form-item label="Доступна доставка">
        <el-checkbox v-model="form.delivery_available"></el-checkbox>
      </el-form-item>
      <el-form-item
        label-width="486px"
        label="Показывать время работы и телефон этого магазина на главной?"
      >
        <el-checkbox v-model="form.main"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="(e) => storeCity(e)"
          >Изменить</el-button
        >
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import getErrors from "../../composable/utils/getErrors";

export default {
  name: "BannerCreate",
  data: function () {
    return {
      form: {
        title: "",
        address: "",
        workTime: "",
        phone: "",
        sort: 1,
        activity: true,
        delivery_available: true,
        email: "",
        city: "",
        main: false,
        coordinates: {
          latitude: 0,
          longitude: 0,
        },
      },
      errors: [],
      cities: [],
      status: 0,
      isLoad: true,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    back() {
      this.$router.push("/storages");
    },
    getCities() {
      axios.get("/api/admin/storage/cities").then((response) => {
        this.cities = response.data;
      });
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    storeCity(e) {
      let data = {
        title: this.form.title,
        address: this.form.address,
        work_time: this.form.workTime,
        phone: this.form.phone,
        activity: this.form.activity,
        delivery_available: this.form.delivery_available,
        sort: this.form.sort,
        email: this.form.email,
        city: this.form.city,
        main: this.form.main,
        coordinates: {
          latitude: this.form.coordinates.latitude,
          longitude: this.form.coordinates.longitude,
        },
      };

      const btn = this.getTarget(e);
      btn.style.pointerEvents = "none";

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .put("/storage/" + this.$route.params.id, data)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;
          this.$router.push("/storages");
          btn.style.pointerEvents = "all";
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
          if (errors.response.status === 422) {
            this.errors = getErrors(errors.response.data.errors);
          }
        });
    },
    fetch() {
      const id = this.$route.params.id;

      axios
        .get(`/storage/${id}`)
        .then((response) => {
          this.init(response.data);
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }

          this.errors = errors.response.data.errors;
        });
    },
    init(value) {
      if (!value) {
        return;
      }
      this.form.title = value.title || "";
      this.form.address = value.address || "";
      this.form.workTime = value.work_time || "";
      this.form.phone = value.phone || "";
      this.form.delivery_available = value.delivery_available || false;
      this.form.sort = value.sort || 0;
      this.form.activity = value.activity || false;
      this.form.email = value.email || "";
      this.form.city = value.city || "";
      this.form.main = value.main || false;
      this.form.coordinates.latitude = value.coordinates.latitude || 0;
      this.form.coordinates.longitude = value.coordinates.longitude || 0;
    },
  },
};
</script>

<style scoped></style>
